<template>
  <div class="separation-anxiety-description">
    <div>
      Does your dog have separation anxiety? Do they show high levels of distress when left alone?
      If your dog does any of the following behaviors when left alone, they might be experiencing separation anxiety or isolation distress:
      <ul>
        <li>barking or howling</li>
        <li>destruction of items in the home</li>
        <li>panting or excessive drooling</li>
        <li>trembling</li>
        <li>peeing/pooping in the house after being house trained</li>
        <li>pawing or scratching at exit points/attempts to escape</li>
        <li>unwillingness to eat</li>
        <li>self-mutilation (biting, licking, scratching, etc. to the point of pain)</li>
      </ul>
    </div>
    <div>
      Separation anxiety can feel overwhelming but thankfully there are tried and true strategies for helping your dog learn to become
      more comfortable when left alone. The separation anxiety training is best done fully remotely so we are able to help no matter
      where your location is.
    </div>
  </div>
</template>

<script>

export default {
  name: 'separation-anxiety-description',
}
</script>

<style scoped lang="scss">
.separation-anxiety-description {
  div {
    margin-top: 2rem;
  }

  ul {
    margin-left: 2rem;

    li {
      margin-top: 0.8rem;
      list-style: circle;

      .italic {
        margin-top: 0;
        font-style: italic;
      }
    }
  }
}
</style>
